<script setup lang="ts">
import { ref } from 'vue'
import BaseWebTabs from "@/components/layouts/BaseWebTabs.vue"
import BaseSide from "@/components/layouts/BaseSide.vue"

const token = localStorage.getItem('token')
const isLoginPage = ref(!token)
</script>

<template>
  <template v-if="isLoginPage">
    <router-view />
  </template>
  <template v-else>
    <div class="layout-container">
      <!-- 左侧菜单 -->
      <div class="left-menu">
        <BaseSide />
      </div>

      <!-- 右侧内容 -->
      <div class="right-panel">
        <!-- 顶部标签栏 -->
        <div class="header">
          <BaseWebTabs />
        </div>

        <!-- 主体内容区域 -->
        <div class="content">
          <router-view />
        </div>
      </div>
    </div>
  </template>
</template>

<style scoped>
html, body {
  height: 100%;
  margin: 0;
  overflow: hidden;
}

.layout-container {
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}



.header {
  height: 50px;
  padding: 16px;
  flex-shrink: 0;
}


</style>
